
var InsertCss = require('insert-css');

var internals = {
	
	id : 0,
	
	createElement : function( html, className ) {
		var div = document.createElement('div');
		div.innerHTML = html;
		return div.getElementsByClassName( className )[0]
	},
	
	template : _.template( "<div class='poem-slider <%= className %>'>\n\t<label class='poem-slider-message' for='poem-slider-<%- id %>'><%= message %></label>\n\t<div class='poem-slider-input-wrapper'>\n\t\t<input\n\t\t\ttype='range'\n\t\t\tmin='<%- min %>'\n\t\t\tmax='<%- max %>'\n\t\t\tstep='<%- step %>'\n\t\t\tvalue='<%- value %>'\n\t\t\tclass='poem-slider-input'\n\t\t\tid='poem-slider-<%- id %>'\n\t\t/>\n\t</div>\n\t<div class='poem-slider-cta-wrapper'>\n\t\t<button class='poem-slider-cta'><%- callToAction %></button>\n\t</div>\n</div>" ),
	
	attachCss : _.once(function() {
		InsertCss( Buffer("LnBvZW0tc2xpZGVyIHsKICAgIHRvcDogNTAlOwogICAgcG9zaXRpb246IGFic29sdXRlOwogICAgbGVmdDogMTIuNSU7CiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7CiAgICB3aWR0aDogNzUlOwogICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC01MCUpOwogICAgYm9yZGVyOiAxcHggc29saWQgIzQyNDI0MjsKICAgIHBhZGRpbmc6IDNlbTsKICAgIGJhY2tncm91bmQtY29sb3I6ICMyNTI1MjU7CiAgICBib3gtc2hhZG93OiAycHggMnB4IDAgIzE4MTgxODsKICAgIGJvcmRlci1yYWRpdXM6IDAuMmVtOwp9Ci5wb2VtLXNsaWRlci1tZXNzYWdlIHsKICAgIGRpc3BsYXk6IGJsb2NrOwogICAgY29sb3I6ICM3QjdCN0I7CiAgICBmb250LXNpemU6IDEuMmVtOwogICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTsKICAgIGZvbnQtd2VpZ2h0OiAzMDA7Cn0KLnBvZW0tc2xpZGVyLWlucHV0LXdyYXBwZXIgewogICAgbWFyZ2luOiAxZW07Cn0KLnBvZW0tc2xpZGVyLWN0YS13cmFwcGVyIHsKfQoucG9lbS1zbGlkZXItY3RhIHsKCWJhY2tncm91bmQ6IG5vbmU7Cglib3JkZXI6IG5vbmU7Cgl0cmFuc2l0aW9uOiB0cmFuc2Zvcm0gMjAwbXM7CgliYWNrZ3JvdW5kLWNvbG9yOiAjNDQ4Q0NDOwoJZm9udC1zaXplOiAxLjRlbTsKCWNvbG9yOiAjMjIyOwoJcGFkZGluZzogMC4zZW0gMWVtOwoJYm9yZGVyLXJhZGl1czogMC4yZW07Cglib3gtc2hhZG93OiAwLjJlbSAwLjJlbSAwLjdlbSByZ2JhKDAsIDAsIDAsIDAuNDMpOwoJcG9zaXRpb246IHJlbGF0aXZlOwoJcGFkZGluZy1yaWdodDogMS45ZW07CgljdXJzb3I6IHBvaW50ZXI7Cgl0cmFuc2Zvcm06IHNjYWxlKDEpOwp9Ci5wb2VtLXNsaWRlci1jdGE6aG92ZXIgewoJYmFja2dyb3VuZC1jb2xvcjogIzUyQTJFQTsKCXRyYW5zZm9ybTogc2NhbGUoMS4wMyk7Cn0KLnBvZW0tc2xpZGVyLWlucHV0LXdyYXBwZXIgewogICAgbWFyZ2luOiA1JTsKfQoucG9lbS1zbGlkZXItY3RhOmFmdGVyIHsKICAgIHBvaW50ZXItZXZlbnRzOiBub25lOwogICAgY29udGVudDogIiI7CiAgICB3aWR0aDogMDsKCWhlaWdodDogMDsKCWJvcmRlci1zdHlsZTogc29saWQ7CiAgICBib3JkZXItd2lkdGg6IDAuNWVtIDAgMC41ZW0gMC42ZW07CiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50IHRyYW5zcGFyZW50IHRyYW5zcGFyZW50ICMyMjI7CiAgICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgICByaWdodDogMC43ZW07CiAgICB0b3A6IDAuNDVlbTsKfQoucG9lbS1zbGlkZXItaW5wdXQgewogICAgd2lkdGg6IDEwMCU7Cn0KCkBtZWRpYSAobWF4LXdpZHRoOjcwMHB4KSB7CgkucG9lbS1zbGlkZXIgewoJICAgIHdpZHRoOiA5MCU7CgkgICAgbGVmdDogNSU7CgkgICAgZm9udC1zaXplOiAwLjllbTsKCX0KfQ==","base64") )
	}),
	
	handleSubmitFn : function( config, poem, el ) {
		
		return function() {
			
			var number = Number( el.getElementsByClassName('poem-slider-input')[0].value )
		
			config.callback( poem, number)
		
			if( config.destroyOnSubmit ) {
				internals.destroy( el )
			}
		
			return false
		}
	},
	
	bootElement : function( config, poem ) {
		
		internals.attachCss()
		
		var html = internals.template( _.extend({
			id: internals.id++
		}, config))
		
		var el = internals.createElement( html, "poem-slider" )
		
		el	.getElementsByClassName('poem-slider-cta')[0]
			.addEventListener( 'click', internals.handleSubmitFn( config, poem, el ), false )
		
		config.targetEl.appendChild( el )
		
		poem.emitter.on('destroy', _.partial( internals.destroy, el ) )
	},
	
	destroy : function( el ) {
		
		if( el && el.parentElement ) {
			el.parentElement.removeChild( el )
		}
	}
}

module.exports = function slider( poem, properties ) {
	
	var config = _.extend({
		targetEl : document.body
	  , message : "Adjust the Slider"
	  , className : ""
	  , min: 1
	  , max: 10
	  , step: 1
	  , value: 5
	  , callToAction: "Start"
  	  , callback : function() { return false }
	}, properties)
	
	internals.bootElement( config, poem )
	
	return {}
}